import React from 'react';
import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import ReactGA from 'react-ga4';
import './index.css';
import App from './App';
import './i18n';

// Google Analytics
const GA_MEASUREMENT_ID = 'G-ZNWDJVFX79';
ReactGA.initialize(GA_MEASUREMENT_ID);

export const sendPageView = (path) => {
  ReactGA.send({ hitType: "pageview", page: path });
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </React.StrictMode>
);